import { render, staticRenderFns } from "./InventoryMiscChargesTable.vue?vue&type=template&id=6e50687c&scoped=true"
import script from "./InventoryMiscChargesTable.vue?vue&type=script&lang=js"
export * from "./InventoryMiscChargesTable.vue?vue&type=script&lang=js"
import style0 from "./InventoryMiscChargesTable.vue?vue&type=style&index=0&id=6e50687c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e50687c",
  null
  
)

export default component.exports